'use client';

import { useSelector } from '@xstate/react';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { useOverlayItem } from '@flipster/overlay';
import { Modal } from '@flipster/react/design-system-legacy/modal';

import MfaVerifyFlowModalContent from './MfaVerifyFlowModalContent';
import { mfaVerifyFlowBunja } from './bunja';

interface Props {
  onConfirm?: (mfaSessionToken: string) => unknown;
}

const MfaVerifyFlow = ({ onConfirm }: Props) => {
  const { onClose: onCloseModal } = useOverlayItem();

  const { mfaVerifyActorAtom } = useBunja(mfaVerifyFlowBunja);
  const mfaVerifyActor = useAtomValue(mfaVerifyActorAtom);

  const { isLoading, isMfaRegisterPhase, isMfaPhase, isPasskeyPhase } = useSelector(mfaVerifyActor, (snapshot) => ({
    isLoading: snapshot.matches('INITIATING'),
    isMfaRegisterPhase: snapshot.matches('REQUIRE_MFA'),
    isMfaPhase: snapshot.matches('VERIFYING') || snapshot.matches('WAIT_FOR_DONE'),
    isPasskeyPhase: snapshot.matches('PASSKEY'),
  }));

  const handleClose = () => {
    onCloseModal();
  };

  if (!(isLoading || isMfaRegisterPhase || isMfaPhase || isPasskeyPhase)) return null;

  return (
    <Modal css={{ minH: 538 }}>
      <Modal.Close onClose={handleClose} />
      <MfaVerifyFlowModalContent onConfirm={onConfirm} />
    </Modal>
  );
};

export default MfaVerifyFlow;
